import { combineReducers } from 'redux';
import search from './search-questions';
import state from './state';
import topicQuery from './topic-query';
import filter from './filter';

export default combineReducers({
	search,
	filter,
	topicQuery,
	state,
});
